import { NgpDialogConfig } from 'ng-primitives/dialog';

export interface SuiDialogConfig<T = any> extends NgpDialogConfig<T> {
  size?: 'small' | 'medium' | 'large' | 'fullscreen' | 'auto';

  // * Custom width. Supports:
  // * - Numbers: treated as px (e.g., 1024 → "1024px")
  // * - Strings: CSS units (e.g., "80vw", "80%", "1024px", "50rem")
  // * Recommended: use "vw" for viewport-relative widths
  width?: number | string;

  // * Custom height. Supports same units as width.
  height?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  minWidth?: number | string;
  minHeight?: number | string;

  // * z-index for the dialog.
  // * automatically calculated by DialogService for stacking
  // * manual override is possible but not recommended
  zIndex?: number;

  // * Opt-in: blur the page behind the overlay (command palette, WAP-1692).
  // * The overlay colour is unchanged; only the backdrop-filter is added.
  blurOverlay?: boolean;
}

// * Viewport ceiling for numeric width/height/min* (e.g. minWidth: 1536
// * becomes min(1536px, 95vw)).
// * When a string ('1536px') is provided, it is passed through, no clamp is applied.
export const DIALOG_VIEWPORT_LIMITS = {
  width: '95vw',
  height: '90vh',
} as const;

// * Predefined size definitions
export const DIALOG_SIZES: Record<
  string,
  {
    width?: string;
    height?: string;
    minWidth?: string;
    minHeight?: string;
    maxWidth?: string;
    maxHeight?: string;
  }
> = {
  small: {
    width: '600px',
    height: '500px',
  },
  medium: {
    width: '900px',
    height: '700px',
  },
  large: {
    width: '1200px',
    height: '800px',
  },
  fullscreen: {
    width: '95vw',
    height: '95vh',
  },
  auto: {
    width: 'auto',
    height: 'auto',
    minWidth: '400px',
    minHeight: '300px',
  },
};
